import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Col from '@prism/col';

import COL_PROP_TYPES from '../constants';

class PrismCol extends React.PureComponent {
    static propTypes = {
        ...COL_PROP_TYPES,
        title: PropTypes.string
    };

    render() {
        const {
            className,
            headerName,
            title,
            colProps,
            children
        } = this.props;

        const colClassName = classNames(
            'col',
            className
        );

        return (
            <Col
                {...colProps}
                className={colClassName}
                title={title}
                data-header={headerName}
            >
                {children}
            </Col>
        )
    }
}

export default PrismCol;
